import React from 'react';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';
import ProgramGroupMessage from '../ProgramGroupMessage/ProgramGroupMessage';

function OutsideFilterMessage(props) {
    const {event, items, unfilteredGroup} = props,
        i18n = useI18n();

    if (unfilteredGroup.length <= items.length) return null;

    let message;
    if (unfilteredGroup.length - items.length > 1) {
        message = i18n['items-outside-filter'].replace('{0}', unfilteredGroup.length - items.length);
    } else {
        message = i18n['item-outside-filter'].replace('{0}', unfilteredGroup.length - items.length);
    }

    return <ProgramGroupMessage event={event}>{message}</ProgramGroupMessage>;
}

export default OutsideFilterMessage;
